/**
 * General communication constants - methods, paths.
 */
class C_Comm
{
    constructor()
    {
        this.GET = "GET";
        this.POST = "POST";

        this.INIT = "init";
        this.PLAY = "play";

        this.LIST_ROOMS = "list-rooms";
        this.ENTER_ROOM = "room-enter";
        this.FIRE = "fire";
    }

}

export default (new C_Comm);